import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}
// Set timezone to Mountain Time
const TIMEZONE = 'America/Denver';
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-timezone': TIMEZONE,
    },
  },
});
export type {
  Client, ClientPlatformId, ClientBrandAsset,
  ClientNote, ClientFile, ClientTimelineEvent, ClientRepo,
  Task, TaskAttachment, TaskComment,
  ClientKbFile, AiJob
} from './supabase.types';